
/* styles */
require("!!./../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter?id=data-v-c770e80a&scoped=true!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Purchase.vue")

var Component = require("!./../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./Purchase.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-c770e80a!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./Purchase.vue"),
  /* scopeId */
  "data-v-c770e80a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchase.vue
// module id = 454
// module chunks = 1